import { z } from "zod";

import { transcriptTypeEnum } from "../enums/transcriptTypeEnum";
import { queueHlsObject } from "./queue/queueHlsObject";
import { trackSchema } from "./trackSchema";

export const playableMediaSchema = trackSchema
  .omit({ prayer_id: true })
  .extend({
    bg_sounds_enabled: z.boolean(),
    hls: queueHlsObject.nullable(),
    intro_ends_at: z.number().nullable(),
    pauses: z.number().array(),
    resumes_at: z.number().nullable(),
    resumes_session_id: z.guid().nullable(),
    show_music_controls: z.boolean(),
    speed_changes_enabled: z.boolean(),
    url: z.string().nullable(),
    prayer_id: z.number().nullable(),
    transcript_url: z.string().nullable(),
    transcript_type: transcriptTypeEnum.nullable(),
    is_autotranscribed: z.boolean(),
  });

export type PlayableMedia = z.infer<typeof playableMediaSchema>;
